import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Typography } from '@mui/material';
import { RadioListItem } from 'components/Input/Radio';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import SwitchFormItem from 'components/Input/Switch';
import { BtnAdd, BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import moment from 'moment';
import { AutoCompleteItem } from 'components/Input/AutoComplete';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnDeleteOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
const ProjectTimelineForm = () => {
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/ProjectTimelineList?sMode=" + sMode);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrYear, setarrYear] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const sMode = new URLSearchParams(searchParams).get("sMode");
    const [dMinYear, setMinYear] = useState() as any;
    const [dMaxYear, setMaxYear] = useState() as any;
    const [isDelete, setisDelete] = useState(false);
    const [dMinYearStart, setMinYearStart] = useState() as any;
    const [dMaxYearStart, setMaxYearStart] = useState() as any;


    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });
    const form = useForm({
        shouldFocusError: true,
        mode: "all"

    });
    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1);

    const handleAddItem = () => {
        //set max and min date of year
        let dYear = moment(form.getValues("dYear"));
        let dMin = new Date(dYear.year(), 0, 1);
        setMinYear(dMin);
        let dMax = new Date(dYear.year(), 11, 31);
        setMaxYear(dMax);

        if (sID == null) {
            form.setValue("dStart", dMin);
            form.setValue("dEnd", dMax);

        }

    }



    const handleAddItemdStart = () => {
        //set max and min date of year
        let dYear = moment(form.getValues("dStart"));
        let dMin = new Date(dYear.year(), 0, dYear.day());
        setMinYearStart(dMin);
        let dMax = new Date(dYear.year(), 11, 31);
        setMaxYearStart(dMax);

    }

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const getFormInitial = () => {
        AxiosFn.Post(`ProjectTimeline/GetFormInitial`, {}, (result) => {
            setarrYear(result.lstYear || []);
        })
    }
    useEffect(() => {
        getFormInitial();
        GetProjectTimelineEdit();
    }, []);

    const handleCheckSameYear = (e) => {
        if (moment(form.getValues("dStart")).year() !== moment(form.getValues("dYear")).year()) {
            DialogFn.Warning("ไม่สามารถบันทึกข้อมูล เนื่องจากวันเปิดรอบไม่ตรงกับปีที่เลือก");
        } else {
            onSubmit(e);
        }
    };

    const onSubmit = (e) => {
        let lstData = [];
        lstData = dataRow.arrRows;
        lstData.forEach((f) => {
            f.nUserID = f.value ? f.value : 0;
            f.nUserAccountID = f.nUserAccountID ? f.nUserAccountID : 0;
            f.nRegisterTimelineID = f.nRegisterTimelineID ? f.nRegisterTimelineID : 0;
        });

        let param = {
            sID: sID ? sID : "",
            nYear: moment(form.getValues("dYear")).valueOf(),
            nStart: form.getValues("dStart").valueOf(),
            nEnd: form.getValues("dEnd").valueOf(),
            nEffective: form.getValues("dEffective") ? form.getValues("dEffective").valueOf() : 0,
            nRegisterType: sMode == "Normal" ? 1 : 2,
            isActive: form.getValues("isActive"),
            lstDataUser: lstData,
            sLocation: location.pathname
        };

        if (lstData.length === 0 && sMode == "Special") {
            DialogFn.Warning("กรุณาเพิ่ม ชื่อบัญชี (อีเมลผู้ขอทุน)");
        } else {
            DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
                DialogFn.BlockUI();
                AxiosFn.Post(`ProjectTimeline/SaveProjectTimeline`, param, (result) => {
                    DialogFn.UnBlockUI();
                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit()
                    navigate(`/ProjectTimelineList?sMode=` + sMode);
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
        }
    };

    const GetProjectTimelineEdit = () => {
        let param = {
            sID: sID ? sID : ""
        };
        setLoading(true);
        AxiosFn.Post(`ProjectTimeline/GetProjectTimelineEdit`, param, (result) => {
            if (sID) {

                form.setValue("dYear", result.sYear);
                form.setValue("dStart", moment(result.nStart));
                form.setValue("dEnd", moment(result.nEnd));
                form.setValue("dEffective", moment(result.nEffective));
                form.setValue("isActive", result.isActive);
                form.setValue(`nRegisterType`, result.nRegisterType);
                setisDelete(result.isDelete);
                setDataRow({
                    ...dataRow,
                    arrRows: result.lstTimelineUser
                });
                setLoading(false);
                handleAddItem();
            }
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    const dataColumn: any = [
        {
            field: "nOrder",
            headerName: "ลำดับ",
            align: "center",
            resizable: false,
            sortable: false,
            width: 60,
            disableColumnMenu: true,
        },
        {
            field: "sUserName",
            headerName: "ชื่อ - สกุล",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,

        },
        {
            field: "sEmail",
            headerName: "อีเมล",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
        },
        {
            field: "ลบ",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            disableColumnMenu: true,
            getActions: (item) => {
                return [
                    <BtnDeleteOnTable
                        IsDisabled={isDelete}
                        id="btnDelete"
                        key={item.row.sID}
                        onClick={() => OnDelete(item.row.sID)}
                    />
                ];

            },
        },
    ];


    const handleSubmit = () => {
        let param = {
            lstUser: form.getValues("nAccountUserID"),
            sLocation: location.pathname,
            lstDataRow: dataRow.arrRows
        }
        setLoading(true);
        AxiosFn.Post(`ProjectTimeline/GetAccount`, param, (result) => {
            setLoading(false);
            setDataRow({
                ...dataRow,
                arrRows: result.lstUser
            });
            form.setValue("nAccountUserID", null);

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        )
    };


    const OnDelete = (sID) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let arrClone = dataRow;
            arrClone.arrRows = arrClone.arrRows.filter((f) => !sID.includes(f.sID));
            //เรียง Order ใหม่
            if (arrClone.arrRows.length > 0) {
                let nOrder = 1;
                arrClone.arrRows.forEach((f) => {
                    f.nOrder = nOrder;
                    f.sID = nOrder + "";
                    nOrder++;
                });
            }
            setDataRow({ ...arrClone });
            DialogFn.Success("ลบข้อมูลสำเร็จ");
        });

    };

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            name={`dYear`}
                            id={`dYear`}
                            label={"ปี"}
                            IsYearPicker
                            minDate={_dStart}
                            required={true}
                            disabled={sID != null || !isPermission}
                            onChange={() => {
                                handleAddItem();
                                form.setValue("dEffective", null);
                            }
                            }

                        />

                    </Grid>
                    <Grid item xs={12} md={6}> </Grid>
                    <Grid item xs={12} md={sMode == "Normal" ? 6 : 5.8} display={"flex"} alignItems={"center"}>
                        <Grid item xs={12} md={sMode == "Normal" ? 4 : 2.7}>
                            <Typography>
                                เปิดรอบวันที่
                                <span style={{ color: "red" }}> * </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}><span>
                            <DatePickerItem
                                name={"dStart"}
                                id={"dStart"}
                                label={"ตั้งแต่วันที่"}
                                fullWidth
                                disabled={sID != null || !isPermission}
                                minDate={dMinYear}
                                maxDate={dMaxYear}
                                view={["month", "day"]}
                                onChange={() => { handleAddItemdStart() }}

                            /></span></Grid>
                    </Grid>

                    <Grid item xs={12} md={6} display={"flex"} alignItems={"center"}>
                        <Grid item xs={12} md={2.5}>
                            <Typography>
                                ปิดรอบวันที่
                                <span style={{ color: "red" }}> * </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}><span>
                            <DatePickerItem
                                name={"dEnd"}
                                id={"dEnd"}
                                label={"ถึงวันที่"}
                                fullWidth
                                disabled={!isPermission}
                                minDate={form.watch("dStart")}
                                maxDate={dMaxYear}
                                view={["month", "day"]}

                            />
                        </span></Grid>
                    </Grid>
                    {sMode == "Normal" ? (
                        <Grid item xs={12} md={6} display={"flex"} alignItems={"center"}>
                            <Grid item xs={12} md={4}>
                                <Typography>
                                    มีผลบังคับใช้ตั้งแต่วันที่
                                    <span style={{ color: "red" }}> * </span>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}><span>
                                <DatePickerItem
                                    name={"dEffective"}
                                    id={"dEffective"}
                                    label={"ถึงวันที่"}
                                    fullWidth
                                    disabled={!isPermission}
                                    minDate={form.watch("dStart")}
                                    required={sMode == "Normal"}
                                    defaultCalendarMonth={moment().startOf('year').year(moment(form.getValues("dStart")).year())}
                                />
                            </span>
                            </Grid>
                        </Grid>
                    ) : <>
                        <Grid item xs={12} md={6}>
                            <AutoCompleteItem
                                id={'nAccountUserID'}
                                name={'nAccountUserID'}
                                sUrlAPI={`ProjectTimeline/GetSearchAccount`}
                                label={`ชื่อบัญชี (อีเมลผู้ขอทุน)`}
                                placeholder={`ชื่อบัญชี (อีเมลผู้ขอทุน)`}
                                required={false}
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item >
                            <BtnAdd id={"btnSave"}
                                onClick={form.handleSubmit(() => { handleSubmit() })}
                            />
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <DataGrid
                                columns={dataColumn}
                                rows={dataRow}
                                isHiddenToolHead={true}
                                isHiddenFooter={true}
                                isShowCheckBox={false}
                                isDisableColumnMenu={true}
                            />
                        </Grid>
                    </>
                    }
                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            width={130}
                            id={"isActive"}
                            disabled={!isPermission}
                        />
                    </Grid>

                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => handleCheckSameYear(e),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>
            </FormProvider>
        </React.Fragment >
    );
}
export default ProjectTimelineForm;
